import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from '../locales/en';
import { vi } from '../locales/vi';

export const DEFAULT_LANGUAGE = 'vi';

/**
 * Tiếng Việt mặc định, tiếng Anh dự phòng — docs/frontend-guide.md §6.
 *
 * `nsSeparator: false` và `keySeparator: '.'`: khoá dạng `auth.signInTitle`.
 * Tắt namespace separator vì chuỗi tiếng Việt có dấu hai chấm (`Lưu ý:`) và
 * i18next sẽ hiểu nhầm phần trước dấu đó là tên namespace.
 */
void i18next.use(initReactI18next).init({
  resources: {
    vi: { translation: vi },
    en: { translation: en },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: 'en',
  nsSeparator: false,
  keySeparator: '.',
  interpolation: {
    // React đã escape sẵn; escape lần nữa biến "Dự án" thành "D&#7921; án".
    escapeValue: false,
  },
});

export { i18next };
